import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import { ReactComponent as EditIcon } from '../../assets/Icons/edit-3.svg'
import { useTraining } from '../../contexts/Training'
import { useCommon } from '../../contexts/common'

const TrainingItem = ({ data }) => {
    const { handleOpen } = useTraining();
    const { certificatesList } = useCommon();

    function onEdit() {
        handleOpen(data);
    }

    const getCertificateName = () => {
        if (data?.type === 'certificate' && data?.type_id) {
            const certificate = certificatesList?.find(cert => cert.id === data.type_id);
            return certificate?.name || '';
        }
        return '';
    };

    return (
        <Box
            component='li'
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    minHeight: 30,
                    '.MuiIconButton-root': {
                        display: 'none',
                    },
                    '&:hover .MuiIconButton-root': {
                        display: 'flex',
                    }
                }}
            >
                <Box>
                    {data?.type === 'certificate' && getCertificateName() && (
                        <Typography variant='body2'>{getCertificateName()}</Typography>
                    )}
                    <Typography variant='body2'>
                        {data?.data?.year} {data?.data?.name} / {data?.data?.focus}
                    </Typography>
                </Box>
                <IconButton
                    sx={{ p: 0.375 }}
                    onClick={onEdit}
                >
                    <EditIcon />
                </IconButton>
            </Box>
        </Box>
    )
}

export default TrainingItem